module.exports = __webpack_public_path__ + "img/2_153.484d0587.png";